import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BroadcastEvent } from '../../interfaces/broadcast-event.interface';

@Injectable({
  providedIn: 'root',
})
export class BroadcastService {
  private eventBus: Subject<BroadcastEvent>;

  constructor() {
    this.eventBus = new Subject<BroadcastEvent>();
  }

  broadcast(key: any, data?: any) {
    this.eventBus.next({ key, data });
  }

  on(key: any): Observable<BroadcastEvent> {
    return this.eventBus
      .asObservable()
      .pipe(filter((event) => event.key === key));
  }
}
